import { render } from "./programmeManagement.vue?vue&type=template&id=e1a6a394&scoped=true"
import script from "./programmeManagement.vue?vue&type=script&lang=js"
export * from "./programmeManagement.vue?vue&type=script&lang=js"

import "./programmeManagement.vue?vue&type=style&index=0&id=e1a6a394&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e1a6a394"

export default script